
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

const mockPosts = [
  {
    id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    user_id: 'mock-user-1',
    user: {
      name: "Valley Organic Farm",
      username: "valleyorganic",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
      verified: true
    },
    content: "Amazing harvest season! Our tomato yields are exceeding expectations. The new irrigation system is working perfectly! 🍅✨",
    image: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
    isVideo: true,
    likes: 45,
    comments: 12,
    timestamp: "2 hours ago",
    crop: "Heirloom Tomatoes",
    harvestWeekMonth: "Week 3 of August 2024",
    location: {
      lat: 36.7783,
      lng: -119.4179,
      address: "Central Valley, CA"
    },
    category: "Organic",
    sentiment: "great",
    whatsHappening: "The tomatoes are ripening faster than expected due to the warm weather",
    challenges: "Need to harvest faster to keep up with ripening",
    created_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'b2c3d4e5-f6g7-8901-bcde-f23456789012',
    user_id: 'mock-user-2',
    user: {
      name: "Sunrise Berry Farm",
      username: "sunriseberries",
      avatar: "https://images.unsplash.com/photo-1472396961693-142e6e269027?w=150&h=150&fit=crop&crop=face",
      verified: true
    },
    content: "Regular day at the farm. Strawberries are coming along nicely. Weather has been pretty standard for this time of year. 🍓",
    image: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
    isVideo: true,
    likes: 28,
    comments: 6,
    timestamp: "4 hours ago",
    crop: "Strawberries",
    harvestWeekMonth: "Month of July 2024",
    location: {
      lat: 36.8783,
      lng: -119.5179,
      address: "Fresno County, CA"
    },
    category: "U-pick",
    sentiment: "standard",
    whatsHappening: "Just maintaining the strawberry plants and keeping an eye on pests",
    challenges: "None at the moment",
    created_at: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'c3d4e5f6-g7h8-9012-cdef-345678901234',
    user_id: 'mock-user-3',
    user: {
      name: "Green Leaf Gardens",
      username: "greenleaf",
      avatar: "https://images.unsplash.com/photo-1466721591366-2d5fba72006d?w=150&h=150&fit=crop&crop=face",
      verified: false
    },
    content: "Really struggling with aphids on my kale! They keep coming back despite trying neem oil multiple times. Anyone have advice? This is getting frustrating! 🥬😤",
    image: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
    isVideo: true,
    likes: 15,
    comments: 28,
    timestamp: "6 hours ago",
    crop: "Kale",
    harvestWeekMonth: "September 2024",
    location: {
      lat: 36.9783,
      lng: -119.6179,
      address: "Madera County, CA"
    },
    category: "Organic",
    sentiment: "help",
    whatsHappening: "Aphids are infesting the kale despite repeated treatments",
    challenges: "Need effective aphid control methods",
    created_at: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'd4e5f6g7-h8i9-0123-defg-456789012345',
    user_id: 'mock-user-4',
    user: {
      name: "Mountain View Ranch",
      username: "mountainview",
      avatar: "https://images.unsplash.com/photo-1493962853295-0fd70327578a?w=150&h=150&fit=crop&crop=face",
      verified: true
    },
    content: "What an incredible year! Our corn is absolutely thriving beyond our wildest dreams. Best harvest we've had in over a decade! 🌽🎉",
    image: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
    isVideo: true,
    likes: 89,
    comments: 22,
    timestamp: "8 hours ago",
    crop: "Sweet Corn",
    harvestWeekMonth: "Week 4 of August 2024",
    location: {
      lat: 37.0783,
      lng: -119.7179,
      address: "Merced County, CA"
    },
    category: "Staples",
    sentiment: "great",
    whatsHappening: "Corn is growing exceptionally well this year",
    challenges: "Managing the large yield and ensuring proper storage",
    created_at: new Date(Date.now() - 8 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'e5f6g7h8-i9j0-1234-efgh-567890123456',
    user_id: 'mock-user-5',
    user: {
      name: "Coastal Citrus Co.",
      username: "coastalcitrus",
      avatar: "https://images.unsplash.com/photo-1465379944081-7f47de8d74ac?w=150&h=150&fit=crop&crop=face",
      verified: true
    },
    content: "Another day, another dollar. Orange trees are doing their thing. Nothing too exciting happening, just maintaining the grove as usual. 🍊",
    image: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/SubaruOutbackOnStreetAndDirt.mp4",
    isVideo: true,
    likes: 22,
    comments: 4,
    timestamp: "12 hours ago",
    crop: "Valencia Oranges",
    harvestWeekMonth: "September 2024",
    location: {
      lat: 36.6783,
      lng: -119.3179,
      address: "Tulare County, CA"
    },
    category: "Orchard",
    sentiment: "standard",
    whatsHappening: "Routine maintenance of the orange grove",
    challenges: "Ensuring consistent watering and nutrient supply",
    created_at: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString()
  }
];

interface ZoneFilters {
  activeTab?: 'climate' | 'hardiness';
  climateZone?: string;
  country?: string;
  hardinessZone?: string;
  showMyZoneOnly?: boolean;
}

export const usePostData = (zoneFilters?: ZoneFilters) => {
  const [posts, setPosts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPosts = async (filters?: ZoneFilters, skipLoadingState = false) => {
    const currentFilters = filters || zoneFilters;
    try {
      if (!skipLoadingState) {
        setLoading(true);
      }
      
      const { data: { user } } = await supabase.auth.getUser();
      console.log('Current user:', user?.id);
      
      // Build the query based on zone filters
      let postsData;
      let postsError;

      // Apply zone filtering if "Show posts from my zone only" is enabled
      if (currentFilters?.showMyZoneOnly && user) {
        // Get current user's zone information
        const { data: userProfile } = await supabase
          .from('profiles')
          .select('climate_zone, hardiness_zone')
          .eq('user_id', user.id)
          .maybeSingle();

        if (userProfile) {
          if (currentFilters.activeTab === 'climate' && userProfile.climate_zone) {
            // Filter posts by users with matching climate zone
            const { data: usersInSameZone } = await supabase
              .from('profiles')
              .select('user_id')
              .eq('climate_zone', userProfile.climate_zone);

            const userIds = usersInSameZone?.map(p => p.user_id) || [];
            
            const result = await supabase
              .from('posts')
              .select('id,user_id,content,image_url,is_video,likes_count,comments_count,created_at,crop_type,harvest_week_month,location_lat,location_lng,location_address,category,sentiment,whats_happening,challenges,crop_plan_info,post_type')
              .neq('post_type', 'cast')
              .in('user_id', userIds)
              .order('created_at', { ascending: false })
              .limit(25);
              
            postsData = result.data;
            postsError = result.error;
          } else if (currentFilters.activeTab === 'hardiness' && userProfile.hardiness_zone) {
            // Filter posts by users with matching hardiness zone
            const { data: usersInSameZone } = await supabase
              .from('profiles')
              .select('user_id')
              .eq('hardiness_zone', userProfile.hardiness_zone);

            const userIds = usersInSameZone?.map(p => p.user_id) || [];
            
            const result = await supabase
              .from('posts')
              .select('id,user_id,content,image_url,is_video,likes_count,comments_count,created_at,crop_type,harvest_week_month,location_lat,location_lng,location_address,category,sentiment,whats_happening,challenges,crop_plan_info,post_type')
              .neq('post_type', 'cast')
              .in('user_id', userIds)
              .order('created_at', { ascending: false })
              .limit(25);
              
            postsData = result.data;
            postsError = result.error;
          } else {
            // No valid zone data, show all posts
            const result = await supabase
              .from('posts')
              .select('id,user_id,content,image_url,is_video,likes_count,comments_count,created_at,crop_type,harvest_week_month,location_lat,location_lng,location_address,category,sentiment,whats_happening,challenges,crop_plan_info,post_type')
              .neq('post_type', 'cast')
              .order('created_at', { ascending: false })
              .limit(25);
              
            postsData = result.data;
            postsError = result.error;
          }
        } else {
          // No user profile, show all posts
          const result = await supabase
            .from('posts')
            .select('id,user_id,content,image_url,is_video,likes_count,comments_count,created_at,crop_type,harvest_week_month,location_lat,location_lng,location_address,category,sentiment,whats_happening,challenges,crop_plan_info,post_type')
            .neq('post_type', 'cast')
            .order('created_at', { ascending: false })
            .limit(25);
            
          postsData = result.data;
          postsError = result.error;
        }
      } else {
        // No zone filtering, show all posts
        const result = await supabase
          .from('posts')
          .select('*')
          .neq('post_type', 'cast')
          .order('created_at', { ascending: false });
          
        postsData = result.data;
        postsError = result.error;
      }

      console.log('🔍 Raw Supabase client response:');
      console.log('Database posts:', postsData);
      console.log('Database error:', postsError);
      console.log('Number of posts returned:', postsData?.length || 0);
      
      if (postsData && postsData.length > 0) {
        console.log('🔍 First post details:', {
          id: postsData[0].id,
          user_id: postsData[0].user_id,
          post_type: postsData[0].post_type,
          content: postsData[0].content?.substring(0, 50) + '...',
          created_at: postsData[0].created_at
        });
      }

      if (postsError) {
        console.error('Database posts error:', postsError);
        setError('Failed to load posts from database');
        setPosts([]);
        return;
      }

      // Now fetch profile data separately to avoid the join issue
      const { data: profilesData, error: profilesError } = await supabase
        .from('profiles')
        .select('user_id, username, farm_name, avatar_url')
        .eq('is_active', true)
        .eq('is_discoverable', true);

      console.log('Profiles data:', profilesData);

      // Create a profile lookup map
      const profileLookup: { [key: string]: any } = {};
      if (profilesData) {
        profilesData.forEach(profile => {
          profileLookup[profile.user_id] = profile;
        });
      }

      let userLikes: string[] = [];
      if (user && postsData && postsData.length > 0) {
        const { data: likesData } = await supabase
          .from('post_likes')
          .select('post_id')
          .eq('user_id', user.id)
          .in('post_id', postsData.map(p => p.id));
        
        userLikes = likesData?.map(like => like.post_id) || [];
      }

      const transformedPosts = (postsData || []).map((post: any) => {
        const profile = profileLookup[post.user_id];
        
        return {
          id: post.id,
          user_id: post.user_id,
          user: {
            name: profile?.farm_name || 'Unknown Farm',
            username: profile?.username || 'unknown',
            avatar: profile?.avatar_url || "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
            verified: Math.random() > 0.5,
          },
          content: post.content,
          image: post.image_url || "https://images.unsplash.com/photo-1618160702438-9b02ab6515c9?w=600&h=400&fit=crop",
          isVideo: post.is_video || false,
          likes: post.likes_count || 0,
          comments: post.comments_count || 0,
          timestamp: formatTimestamp(post.created_at),
          crop: post.crop_type || 'Unknown',
          harvestWeekMonth: post.harvest_week_month || 'Unknown',
          location: {
            lat: parseFloat(post.location_lat) || 36.7783,
            lng: parseFloat(post.location_lng) || -119.4179,
            address: post.location_address || 'Unknown Location'
          },
          category: post.category || 'Produce',
          sentiment: post.sentiment || 'standard',
          isLiked: userLikes.includes(post.id),
          cropPlanInfo: post.crop_plan_info || undefined,
          whatsHappening: post.whats_happening || undefined,
          challenges: post.challenges || undefined,
          created_at: post.created_at
        };
      });

      // If we have real posts, use them; otherwise create user-specific mock posts
      if (transformedPosts.length > 0) {
        console.log('✅ Using real posts from database:', transformedPosts.length);
        console.log('First post preview:', {
          id: transformedPosts[0]?.id,
          content: transformedPosts[0]?.content?.substring(0, 50) + '...',
          user: transformedPosts[0]?.user?.name,
          timestamp: transformedPosts[0]?.timestamp
        });
        setPosts(transformedPosts);
      } else {
        console.log('⚠️ No real posts found - this should show your created posts!');
        console.log('Raw database response:', postsData);
        console.log('User ID:', user?.id);
        
        // FOR NOW: Show empty instead of mock posts so we can debug
        setPosts([]);
        setError('No posts found. If you just created a post, please refresh the page.');
      }
    } catch (err) {
      console.error('Error fetching posts:', err);
      setError('Failed to fetch posts');
      setPosts([]);
    } finally {
      setLoading(false);
    }
  };

  const formatTimestamp = (timestamp: string): string => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInHours = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60));
    
    if (diffInHours < 1) return 'Just now';
    if (diffInHours < 24) return `${diffInHours} hours ago`;
    if (diffInHours < 48) return '1 day ago';
    return `${Math.floor(diffInHours / 24)} days ago`;
  };

  useEffect(() => {
    // Skip loading state for filter changes to prevent white screen flash
    if (posts.length > 0) {
      fetchPosts(undefined, true); // Skip loading state for existing data
    } else {
      fetchPosts(); // Show loading state for initial load
    }
  }, [zoneFilters?.showMyZoneOnly, zoneFilters?.activeTab, zoneFilters?.climateZone, zoneFilters?.hardinessZone]);

  return {
    posts,
    loading,
    error,
    fetchPosts,
    setPosts
  };
};
